<template>
  <div class="card no-body">
    <div class="card-header d-flex">
        <h5 class="h3 mb-0">Recent Media</h5>
        <b-button @click="goTo" size="sm" v-b-popover.hover.left="'Go to Media Search Page'" variant="outline-primary" class="ml-auto">View All</b-button>
    </div>

    <div v-if="!loading">
        <div v-if="media.length > 0">
            <b-list-group flush class="job-list-group">
              <b-list-group-item v-for="entity in media" :key="entity.entityId" class="mx-0 p-0 py-1">
                <entity-list-group-item :entity="entity"></entity-list-group-item>
              </b-list-group-item>
            </b-list-group>
        </div>
        <div v-else class="text-center p-3">
            <div> No media in this project yet. </div>
        </div>
    </div>
    <div v-else class="text-center p-3">
      <b-spinner size="sm"></b-spinner>
    </div>
    <div class="card-footer">
      <b-form-invalid-feedback :state="!session.errorMessage" class="text-center">
          {{session.errorMessage}}
      </b-form-invalid-feedback>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';

import EntityListGroupItem from '#/ui/Components/Entities/EntityListGroupItem.vue';
import { EntityListSession } from '#/services/entities';

export default {
  components: {
    EntityListGroupItem,
  },
  data() {
    return {
      session: new EntityListSession(),
    };
  },
  created() {
    return this.session.loadPage();
  },
  computed: {
    loading() {
      return this.session.loading;
    },
    fullyLoaded() {
      return this.session.loadedLastPage;
    },
    cursor() {
      return this.session.pageCursor;
    },
    limit() {
      return this.session.pageSize;
    },
    media() {
      return this.session.entities;
    },
  },
  methods: {
    ...mapActions('entities', [
      'loadList',
    ]),
    scroll() {
      // TODO: is additional debouncing necessary?
      console.log('MEDIA SCROLL EVENT');
      if (this.session.loading) {
        return;
      }
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.session.loadPage();
      }
    },
    goTo() {
      const path = '/media';
      this.$router.push(path);
    },
  },
};

</script>
<style scoped>
</style>
